<div class="picker-state-grid">

  <div class="search-wrap">
    <svg class="search-icon" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <circle cx="11" cy="11" r="7"/>
      <path d="M21 21l-4.35-4.35"/>
    </svg>
    <input
      class="search-input"
      type="text"
      placeholder="FL or Florida…"
      [value]="searchText()"
      (input)="onSearchInput($any($event.target).value)"
      aria-label="Search states"
    />
  </div>

  <div class="state-grid">
    @for (s of filteredStates(); track s.code) {
      <button
        type="button"
        class="state-cell"
        [class.on]="isSelected(s.code)"
        [attr.aria-label]="s.name"
        [attr.aria-pressed]="isSelected(s.code)"
        [title]="s.name"
        (click)="onToggle(s.code)"
      >{{ s.code }}</button>
    } @empty {
      <div class="empty">No matches.</div>
    }
  </div>

</div>
